import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/paymentRequests/store/paymentRequestSlice/initialState.ts'
import { PaymentRequest } from '@/modules/allies/paymentRequests/types/PaymentRequest.ts'

const paymentRequestSlice = createSlice({
  name: 'paymentRequest',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setLoadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoadingAction = action.payload
    },
    setPaymentRequests: (state, action: PayloadAction<PaymentRequest[]>) => {
      state.paymentRequests = action.payload
    },
    setOpenProcesarPagoModal: (state, action: PayloadAction<boolean>) => {
      state.openProcesarPagoModal = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setSelectedRows: (state, action: PayloadAction<PaymentRequest[]>) => {
      state.selectedRows = action.payload
    },
    clearSelectedRows: (state) => {
      state.selectedRows = []
      state.selectionResetKey += 1
    },
    reset: () => initialState
  }
})

export const paymentRequestActions = paymentRequestSlice.actions
export const { reducer: paymentRequestReducer } = paymentRequestSlice
